import { TOKEN_FRESHCHAT } from "gatsby-env-variables"

export const init = () => {
  window.fcWidget.init({
    token: TOKEN_FRESHCHAT,
    host: "https://wchat.freshchat.com",
    config: {
      headerProperty: {
        direction: "rtr",
        backgroundColor: "#045257",
      },
    },
  })
}
